import React from 'react';
import { useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import FormularioPublico from './pages/FormularioPublico';

export default function App() {
  const { user } = useAuth();

  // Ruta pública /formulario — sin necesidad de login
  if (window.location.pathname === '/formulario') {
    return <FormularioPublico />;
  }

  return user ? <Dashboard /> : <LoginPage />;
}
